module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/4mill-inactive-31255545d7bb4d06e47f04e2269a2313.png";